import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import FunctionButton from "../../components/common/FunctionButton";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import ProgressWrapDiv from "../../components/common/ProgressWrapDiv";
import AgreementDiv from "../../components/common/AgreementDiv";
import MessageDialog from "../../components/common/MessageDialog";
import { useTranslation } from "react-i18next";

const RegAgreementPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const termsOfUseText = [
    `${t("L0348")}${t("L0383")}${t("L0384")}${t("L0385")}${t("L0386")}${t(
      "L0387"
    )}`,
  ]
    .join("")
    .replace(/ {2}/g, "\n");

  const privacyPolicy = [
    `${t("L0351")}${t("L0388")}${t("L0389")}${t("L0390")}${t("L0391")}`,
  ]
    .join("")
    .replace(/ {2}/g, "\n\n");

  const [agreeUse, setAgreeUse] = useState(false);
  const [agreePrivacy, setAgreePrivacy] = useState(false);
  const [agreeAll, setAgreeAll] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleAgreeUseChange = () => {
    setAgreeUse((agreeUse) => !agreeUse);
  };

  const handleAgreePrivacyChange = () => {
    setAgreePrivacy((agreePrivacy) => !agreePrivacy);
  };

  const handleAgreeAllChange = () => {
    if (agreeAll) {
      setAgreeUse(false);
      setAgreePrivacy(false);
    } else {
      setAgreeUse(true);
      setAgreePrivacy(true);
    }

    setAgreeAll((agreeAll) => !agreeAll);
  };

  const handlePreviousClick = () => {
    navigate(-1);
  };

  const handleNextClick = () => {
    if (!validate()) {
      setIsDialogOpen(true);
      return;
    }
    navigate("/join/reg-info", {
      state: {
        waUserId: location.state?.waUserId,
        waPwd: location.state?.waPwd,
        united: location.state?.united,
        country: location.state?.country,
        location: location.state?.location,
        loc: location.state?.loc,
      },
    });
  };

  const handleConfirm = () => {
    setIsDialogOpen(false);
  };

  const validate = () => {
    let isValid = true;

    if (!agreeUse || !agreePrivacy) {
      isValid = false;
    }

    return isValid;
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("L0341"), t("L0342")]}></BreadCrumbDiv>
      <ProgressWrapDiv>
        <li className="active">{`01 ${t("L0344")}`}</li>
        <li>{`02 ${t("L0345")}`}</li>
        <li>{`03 ${t("L0346")}`}</li>
      </ProgressWrapDiv>

      <AgreementDiv>
        <div>
          <h4>Terms of Use</h4>
          <textarea
            readOnly
            style={{ height: "120px" }}
            value={termsOfUseText}
          ></textarea>
          <p className="check">
            <input
              type="checkbox"
              id="checkbox1"
              checked={agreeUse}
              onChange={handleAgreeUseChange}
            />
            <label htmlFor="checkbox1"></label>
            {t("L0349")}
          </p>
        </div>
        <div>
          <h4>{t("L0350")}</h4>
          <textarea
            readOnly
            style={{ height: "120px" }}
            value={privacyPolicy}
          ></textarea>
          <p className="check">
            <input
              type="checkbox"
              id="checkbox2"
              checked={agreePrivacy}
              onChange={handleAgreePrivacyChange}
            />
            <label htmlFor="checkbox2"></label>
            {t("L0352")}
          </p>
        </div>

        <div className="check_all">
          <p className="check">
            <input
              type="checkbox"
              id="checkbox3"
              checked={agreeAll}
              onChange={handleAgreeAllChange}
            />
            <label htmlFor="checkbox3"></label>
            {t("L0353")}
          </p>
        </div>
      </AgreementDiv>

      <ButtonWrapDiv className="btn_bottom">
        <FunctionButton
          className="big bg_gray"
          value={t("L0354")}
          onClick={handlePreviousClick}
        ></FunctionButton>

        <FunctionButton
          className="big"
          value={t("L0355")}
          onClick={handleNextClick}
        ></FunctionButton>
      </ButtonWrapDiv>

      {isDialogOpen && (
        <MessageDialog title={"Information"} message={t("L0356")}>
          <FunctionButton
            value={t("L0004")}
            onClick={handleConfirm}
          ></FunctionButton>
        </MessageDialog>
      )}
    </div>
  );
};

export default RegAgreementPage;
